async function showDiscount() {

  try {

    const res = await fetch("http://localhost:3000/discounts");
    const data = await res.json();

    console.log("DISCOUNT DATA:", data); // FOR DEBUG

    if (!data.percent || data.percent <= 0) return;

    document.querySelectorAll(".price").forEach(el => {

      const raw = el.innerText.replace(/[^0-9.]/g,"");
      const price = parseFloat(raw);

      if (!price) return;

      const discounted = price * (1 - data.percent);
      const pct = Math.round(data.percent * 100);

      const box = document.createElement("div");
      box.innerHTML = `SALE PRICE: $${discounted.toFixed(2)} (${pct}% OFF)`;
      box.style.color = "#c82323";
      box.style.fontWeight = "bold";
      box.style.marginTop = "6px";

      el.parentNode.appendChild(box);

    });

  } catch(e) {
    console.error("Discount display error:", e);
  }

}

showDiscount();
